import { CreateCourseType } from "../../../types/Course";
import { post } from "../../../utils/axios-config";
import { COURSES } from "../../../utils/constants";

export const createCourse = async (data: CreateCourseType) => await post<CreateCourseType, string>(COURSES, data);